"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormSkeleton = /*#__PURE__*/function (_Component) {
  _inherits(FormSkeleton, _Component);

  var _super = _createSuper(FormSkeleton);

  function FormSkeleton(props) {
    var _this;

    _classCallCheck(this, FormSkeleton);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (event) {
      event.preventDefault();
      var submitTries = _this.state.submitTries;
      _this.validElements = 0;
      _this.validatedElements = 0;
      submitTries += 1;

      _this.setState({
        submitTries: submitTries,
        validateForm: false
      });

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "validateFormElement", function (validatedObj) {
      _this.validatedElements = _this.validatedElements + 1;

      if (validatedObj.validated && !validatedObj.errorMsg) {
        _this.validElements = _this.validElements + 1;
      }

      if (_this.validatedElements === _this.activeFormElements) {
        var validationTries = _this.state.validationTries;
        validationTries += 1;

        if (_this.validatedElements === _this.validElements) {
          _this.setState({
            validateForm: true,
            validationTries: validationTries
          });
        } else {
          _this.setState({
            validateForm: false,
            validationTries: validationTries
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "activateFormElement", function () {
      _this.activeFormElements = _this.activeFormElements + 1;
    });

    _defineProperty(_assertThisInitialized(_this), "deactivateFormElement", function () {
      _this.activeFormElements = _this.activeFormElements - 1;
    });

    _this.state = {
      submitTries: 0,
      validateForm: false,
      validationTries: 0
    };
    _this.activeFormElements = 0;
    _this.validatedElements = 0;
    _this.validElements = 0;
    _this.validateForm = false;
    return _this;
  }

  _createClass(FormSkeleton, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          autocomplete = _this$props.autocomplete,
          name = _this$props.name,
          wrapperClass = _this$props.wrapperClass,
          id = _this$props.id,
          children = _this$props.children;
      var _this$state = this.state,
          submitTries = _this$state.submitTries,
          validationTries = _this$state.validationTries;

      var childrenWithProps = _react["default"].Children.map(children, function (child) {
        var validateForm = _this2.state.validateForm;
        return /*#__PURE__*/_react["default"].cloneElement(child, {
          formSkeletonProps: {
            submitTries: submitTries,
            validationTries: validationTries,
            activateFormElement: _this2.activateFormElement,
            deactivateFormElement: _this2.deactivateFormElement,
            validateFormElement: _this2.validateFormElement,
            validateForm: validateForm
          }
        });
      });

      return /*#__PURE__*/(0, _jsxRuntime.jsx)("form", {
        autoComplete: autocomplete,
        name: name,
        className: "formSkeleton ".concat(wrapperClass),
        id: id,
        onSubmit: this.onSubmit,
        children: childrenWithProps
      });
    }
  }]);

  return FormSkeleton;
}(_react.Component);

FormSkeleton.propTypes = {
  autocomplete: _propTypes["default"].string,
  name: _propTypes["default"].string.isRequired,
  wrapperClass: _propTypes["default"].string,
  id: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired
};
FormSkeleton.defaultProps = {
  autocomplete: 'false',
  wrapperClass: '',
  id: 'rfs'
};
var _default = FormSkeleton;
exports["default"] = _default;

//# sourceMappingURL=index.js.map